export default __webpack_public_path__ + "static/media/instructor-pic-2.8d2181bc.JPG";